var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();
FIGURE.debounce = function(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this,
			args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	}
}

FIGURE.downAnimator = function() {
	if ($(".hero-dropdown-arrow").length) {
		$(".hero-dropdown-arrow").hover(() => {
			$(".hero-dropdown-arrow").addClass("no-animation");
		})

		$(window).on("scroll", () => {
			if ($(window).scrollTop() > 100) {
				$(".hero-dropdown-arrow a").hide("slow");
				$(".hero-dropdown-arrow").addClass("no-animation");
			} else {
				$(".hero-dropdown-arrow a").show("slow");
				$(".hero-dropdown-arrow").removeClass("no-animation");
			}
		});
	}
}();
